export default __webpack_public_path__ + "static/media/midasi_entry_th_sp.21865246.png";